'use client';

import Empty from '@/components/atoms/Empty';
import FavouriteLoader from '@/components/atoms/Loaders/FavouriteLoader';
import Modal from '@/components/atoms/Modal';
import InfiniteScrollComponent from '@/components/organisms/InfiniteScrollComponent';
import ProductCardHorizontal from '@/components/organisms/Products/ProductCardHorizontal';
import { API_PUBLIC } from '@/services/ecommerce/apis/apiConstrant';
import { useCallback, useState } from 'react';
import styles from './product.module.scss';

const GenericsModal = ({ data, open, setShowGenericsModal }: any) => {
	const generic = {
		id: data?.p_generic_id,
		name: data?.p_generic_name
	};
	const g_id = generic?.id;
	const [listItemsContainerRef, setListItemsContainerRef] = useState();
	const onlistItemsContainerRefChange = useCallback((node) => {
		if (node !== null) {
			setListItemsContainerRef(node);
		}
	}, []);
	const handleClose = () => {
		setShowGenericsModal(false);
	};

	return (
		<Modal isOpen={open} onClose={handleClose} title={generic?.name} footer={null}>
			<div
				className={styles.generics}
				ref={onlistItemsContainerRefChange}
				style={{
					overflow: 'auto',
					height: 'calc(60vh)'
				}}
				id='scrollableDiv'>
				<InfiniteScrollComponent
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '20px',
						padding: '20px',
						overflow: 'auto'
					}}
					endpoint={API_PUBLIC.GET_PRODUCT_FROM_SEARCH}
					method='GET'
					initialFilter={{
						_generic_id: g_id
					}}
					PAGE_SIZE={10}
					CusomLoader={FavouriteLoader}
					uniqueKey={'pv[0].pv_id'}
					EmptyComponent={
						<div className='d-flex justify-center mt-20'>
							<Empty description='No products found' />
						</div>
					}
					scrollableTarget={listItemsContainerRef}
					className=''>
					{(product, index) => (
						<ProductCardHorizontal
							size='small'
							data={product}
							key={index}
							addToCartProps={{
								label: 'Add',
								buttonStyle: {
									width: '100px',
									height: '30px',
									fontSize: '12px'
								},
								inputStyle: {
									height: '30px'
								}
							}}
						/>
					)}
				</InfiniteScrollComponent>
			</div>
		</Modal>
	);
};

export default GenericsModal;
